import ToggleButton from "../../../../Components/common/ToggleButton/ToggleButton";

import "./headerStatusToggle.scss";

// The "| Status [toggle]" block that sits in the first row of a settings table,
// between the table title and its NOTE, as on the notification settings pages.
// It turns the whole setting on or off.
const HeaderStatusToggle = ({ active, onClick, label = "Status" }) => (
  <div className="header-status-toggle">
    <span>{label}</span>
    <ToggleButton active={active} onClick={onClick} />
  </div>
);

export default HeaderStatusToggle;
